<div class="col-md-12">
  <div class="assign-section">
    <div class="col-md-4">
        <mat-form-field appearance="none" class="form-control search-div">
          <input matInput placeholder="Search by Client Name" [(ngModel)]="searchKey" (keyup)="getClients()"
            #input>
          <button mat-button matSuffix mat-icon-button arai-label="Clear" *ngIf="searchKey" (click)="onSearchClear()" class="mat-icon-button">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button mat-raised-button class="btn Action-buttons" *ngIf="!searchKey" (click)="getClients()" style="background-color: transparent; border: none; z-index:1;
                  box-shadow: 0 0 black;
                  position: absolute;
                  left: 275px;
                  top: 12px;">
          <mat-icon>search</mat-icon>
        </button>
    </div>

    <div class="col-md-4"></div>
    <div class="col-md-4 search-bx-outer">
      <div class="schedule-div1">
        <button mat-raised-button class="btn btn-icon-text3 act-btn" [disabled]="isEditClientDisabled"
        (click)="openEditClientDialog()">
          <i class="fa fa-user-edit" aria-hidden="true"></i> &nbsp; Edit Client</button>
      </div>
      <div class="schedule-div1">
        <button mat-raised-button class="btn btn-icon-text3 act-btn" (click)="openAddClientDialog()">
          <i class="fa fa-user-plus" aria-hidden="true"></i> &nbsp; Add Client</button>
      </div>
    </div>
  </div>
</div>

<div class="col-lg-12 grid-margin stretch-card paddrl35" style="padding-bottom: 20px;">
<div class="card Member-card">
<table mat-table matSort [dataSource]="dataSource" aria-label="Elements" class="display nowrap mat-elevation-z0" style="width:100%" name="search">
<!-- Selected Column -->
<ng-container matColumnDef="selection">
  <mat-radio-group appearance="fill">
    <th mat-header-cell *matHeaderCellDef> &nbsp; </th>
    <td mat-cell *matCellDef="let row">
      <mat-radio-button [value]="row" (click)="radiobuttonClick($event, row)"
        color="primary">
      </mat-radio-button>
    </td>
  </mat-radio-group>
</ng-container>

<!-- Scheduler ID Column -->
<ng-container matColumnDef="clientId">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Id</th>
  <td mat-cell *matCellDef="let element">{{element.clientId}}</td>
</ng-container>

<!-- First Name Column -->
<ng-container matColumnDef="clientName">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
  <td mat-cell *matCellDef="let element"> {{element.clientName}} </td>
</ng-container>

<!-- Last Name Column -->
<ng-container matColumnDef="clientDesc">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Desc</th>
  <td mat-cell *matCellDef="let element"> {{element.clientDesc}} </td>
</ng-container>

<!-- ContactNumber Column -->
<ng-container matColumnDef="createdBy">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
  <td mat-cell *matCellDef="let element">{{element.createdBy}}</td>
</ng-container>

<ng-container matColumnDef="createdTimestamp">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Timestamp</th>
  <td mat-cell *matCellDef="let element">{{element.createdTimestamp}}</td>
</ng-container>

<ng-container matColumnDef="updatedBy">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
  <td mat-cell *matCellDef="let element">{{element.updatedBy}}</td>
</ng-container>

<!-- Address1 Column -->
<ng-container matColumnDef="updatedTimestamp">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated TimeStamp</th>
  <td mat-cell *matCellDef="let element">{{element.updatedTimestamp}}</td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

<!-- Display loading data -->
</table>

<mat-paginator #paginator [showFirstLastButtons]="true" [length]="length" [pageSize]="pageSize"
[pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = getClients($event)" class="mat-paginator12 mat-paginator-sticky">
</mat-paginator>
</div>

</div>
